import React, { Component } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import CloseButton from "./CloseButton";

class AddNoteModal extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleAddNote: PropTypes.func.isRequired,
  };

  state = {
    description: "",
    submitDisabled: true,
  };

  handleSubmitDisabled = () => {
    const { description, submitDisabled } = this.state;
    if (!description && !submitDisabled) this.setState({ submitDisabled: true });
    if (description && submitDisabled) this.setState({ submitDisabled: false });
  };
  handleTitleChange = (e) => {
    this.setState({ title: e.target.value }, this.handleSubmitDisabled);
  };
  handleDescriptionChange = (e) => {
    this.setState({ description: e.target.value }, this.handleSubmitDisabled);
  };

  handleSubmit = () => {
    const { description } = this.state;
    const { handleAddNote, handleClose } = this.props;
    handleAddNote(description);
    handleClose();
  };

  render() {
    const { open, handleClose } = this.props;
    const { description, submitDisabled } = this.state;

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{
          paper: "dialog",
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <CloseButton handleClose={handleClose} />
        <DialogTitle id="responsive-dialog-title" className="text-center">
          إضافة ملاحظة جديدة
        </DialogTitle>
        <DialogContent>
          <div className="form-group">
            <TextField
              rows={4}
              placeholder="النص"
              fullWidth
              required
              value={description}
              onChange={this.handleDescriptionChange}
              multiline
              variant="outlined"
              size="small"
            />
          </div>
        </DialogContent>
        <DialogActions className="justify-content-center align-items-center">
          <Button
            onClick={this.handleSubmit}
            color="primary"
            variant="contained"
            className="dialog__btn"
            disabled={submitDisabled}
          >
            حفظ
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default AddNoteModal;
